import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Show, SignOutButton } from '@clerk/react'
import { LogIn, LogOut, UserPlus } from 'lucide-react'
import '../Styles/LandingPage.scss'

const StartLogin = () => {
  const navigate = useNavigate();

  return (
    <div className="nav-auth-buttons">
      <Show when="signed-out">
        <button
          className="nav-link nav-link--signup"
          onClick={() => navigate('/sign-up')}
        >
          <UserPlus size={16} />
          <span>Sign Up</span>
        </button>
        <button
          className="nav-link nav-link--login"
          onClick={() => navigate('/sign-in')}
        >
          <LogIn size={16} />
          <span>Sign In</span>
        </button>
      </Show>
      <Show when="signed-in">
        <SignOutButton redirectUrl="/">
          <button className="nav-link nav-link--login">
            <LogOut size={16} />
            <span>Log Out</span>
          </button>
        </SignOutButton>
      </Show>
    </div>
  )
}

export default StartLogin
